import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Default from "./layouts/default.vue";
import Auth from "./layouts/auth.vue";
import axios from 'axios'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js/auto'
import { QrcodeStream } from "vue-qrcode-reader";
import { URL_API } from './config'

axios.defaults.baseURL = URL_API
const token = localStorage.getItem('token');
if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

const app = createApp(App)

app.use(router)
app.use(store)
app.use(Chartkick.use(Chart))
app.component('Default', Default)
app.component('Auth', Auth)
app.component('QrcodeStream', QrcodeStream)

app.mount('#app')